import { IconProps } from "@/models/Icon";

export function ArrowDownIcon2({ 
    size = 24, 
    color = "#1D1B1C", 
}: IconProps) {
    return(
        <svg width={size} height={size}viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 10L12 14L16 10" stroke="#1D1B1C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}